<template>
  <div>
    <b-icon v-if="value"
    icon="check-circle-fill"
    :style="{ color: successColor}"
    :font-scale="0.9"/>
    <b-icon v-else
    icon="x-circle-fill"
    :style="{ color: frownColor}"
    :font-scale="0.9"/>
  </div>
</template>
<script>
import AppConfig from "@/mixins/AppConfig";
export default {
  props: {
    value:          { type: Boolean },
    colorRange:     { type: Array,  required: true },
  },
  mixins: [AppConfig],
  computed: {
    successColor() {
      return this.colorRange.find(s => s.Smiley == "grin")?.Color;
    },
    mehColor() {
      return this.colorRange.find(s => s.Smiley == "meh")?.Color;
    },
    frownColor() {
      return this.colorRange.find(s => s.Smiley == "frown-open")?.Color;
    },
  }
}
</script>
<style>

</style>